import Component from './EditCustomer.container';

export default Component;
